import { useLocation } from 'react-router-dom';

export default function useQueryStringParams(params: string | string[]) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const desiredParams = Array.isArray(params) ? params : [params];

  return desiredParams.reduce(
    (obj, param) => {
      obj[param] = searchParams.get(param);

      return obj;
    },
    {} as Record<string, string | null>
  );
}
